import getSites from './getSites'
import { apolloClient } from 'lib/withApollo'
import SITES_QUERY from 'graphql/sites.query'

const getSitesForStaticPaths = async (
  query = null,
  processItems = null,
  hasMore = null
) => {
  const sites = await getSites()
  if (!sites) return null

  if (!query) return sites.map((s) => s.path.replace(/\//g, ''))

  // todo: add more error handling on the various fetches
  return await Promise.all(
    sites.map((site) => {
      const siteSlug = site.path.replace(/\//g, '')
      const items = []

      return new Promise((resolve, reject) => {
        const runQuery = (offset) => {
          const freshClient = apolloClient()
          freshClient
            .query(query({ site: siteSlug, offset }))
            .then(async ({ data }) => {
              const newItems = await processItems(data, {
                offset,
                client: freshClient,
                site: siteSlug,
              })

              if (Array.isArray(newItems))
                newItems.forEach((p) => items.push(p))
              else items.push(newItems)

              if (typeof hasMore === 'function' && hasMore(data)) {
                runQuery(
                  Array.isArray(newItems)
                    ? offset + newItems.length
                    : newItems.offset
                )
              } else {
                resolve([siteSlug, items])
              }
            })
            .catch((err) => {
              console.error(
                'Error fetching graphql query in getSitesForStaticPaths',
                err,
                siteSlug,
                offset,
                query({ site: siteSlug, offset })
              )
              reject('Error fetching graphql query in getSitesForStaticPaths')
            })
        }

        return runQuery(0)
      })
    })
  )
}

export default getSitesForStaticPaths
